import { render, staticRenderFns } from "./ModalAddQuize.vue?vue&type=template&id=544e4821&scoped=true"
import script from "./ModalAddQuize.vue?vue&type=script&lang=js"
export * from "./ModalAddQuize.vue?vue&type=script&lang=js"
import style0 from "./ModalAddQuize.vue?vue&type=style&index=0&id=544e4821&prod&lang=scss"
import style1 from "./ModalAddQuize.vue?vue&type=style&index=1&id=544e4821&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544e4821",
  null
  
)

export default component.exports